export default __webpack_public_path__ + "static/media/teacher_one.515debde.png";